// blocks/slider/view.js
document.addEventListener('DOMContentLoaded', () => {
  const sliders = Array.from(
    document.querySelectorAll('.wp-block-printmasters-slider')
  );

  if (!sliders.length) {
    return;
  }

  sliders.forEach((sliderEl, index) => {
    const speedModifier = index * 300;

    const itemsRow = Number(sliderEl.dataset.itemsRow) || 1;
    const delay = Number(sliderEl.dataset.delay) || 4000;
    const loopRequested = sliderEl.dataset.loop === 'true';
    const spaceBetween = Number(sliderEl.dataset.spaceBetween) || 0;
    const navigation = sliderEl.dataset.navigation === 'true';
    const hasThumbs = sliderEl.dataset.thumbs === 'true';

    // Count slides for this slider
    const slideCount = sliderEl.querySelectorAll(
      '.swiper-slide, .wp-block-printmasters-slide'
    ).length;

    // Same breakpoint logic you had before, but reusable
    const spvMobile = itemsRow === 1 ? 1 : 2; // ≥600
    const spvTablet = itemsRow <= 2 ? itemsRow : 3; // ≥840
    const spvDesktop = itemsRow; // ≥1200

    const maxSlidesPerView = Math.max(1, spvMobile, spvTablet, spvDesktop);

    // Only allow loop when there are enough slides
    const loop = loopRequested && slideCount > maxSlidesPerView;

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween,
      // Swiper sees these as slides via either class:
      slideClass: 'wp-block-printmasters-slide',
      loop,
      autoplay: {
        delay: delay + speedModifier,
        disableOnInteraction: false,
      },
      breakpoints: {
        600: {
          slidesPerView: spvMobile,
        },
        840: {
          slidesPerView: spvTablet,
        },
        1200: {
          slidesPerView: spvDesktop,
        },
      },
    };

    if (navigation) {
      // Scope buttons to this slider wrapper so multiple sliders don't conflict
      const wrapper = sliderEl.closest(
        '.wp-block-printmasters-slider-wrapper'
      );

      swiperConfig.navigation = {
        nextEl:
          wrapper && wrapper.querySelector('.wp-block-slider-button-next')
            ? wrapper.querySelector('.wp-block-slider-button-next')
            : '.wp-block-slider-button-next',
        prevEl:
          wrapper && wrapper.querySelector('.wp-block-slider-button-prev')
            ? wrapper.querySelector('.wp-block-slider-button-prev')
            : '.wp-block-slider-button-prev',
      };
    }

    // If you ever use thumbs, you can re-add that logic here.
    // For now, keep it simple and only handle the main slider:
    if (!hasThumbs) {
      try {
        new Swiper(sliderEl, swiperConfig);
      } catch (err) {
        console.error('Error initialising Swiper slider:', err);
      }
      return;
    }

    // If hasThumbs === true but you don't have thumbs markup yet,
    // just init main slider for now:
    try {
      new Swiper(sliderEl, swiperConfig);
    } catch (err) {
      console.error('Error initialising Swiper slider (thumbs mode):', err);
    }
  });
});
